import { QueryClient } from '@tanstack/react-query';

/**
 * Shared TanStack Query client configured with default options.
 * Enforces staleTime of 30,000 ms per requirements.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30000, // 30 seconds default stale time
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});
